<app-nav-bar></app-nav-bar>
<div class="videos-wrapper is-home">
  <!-- /html/partials/pages/videos/videos-sidebar.html -->
  <app-videos-sidebar></app-videos-sidebar>
  <!-- Homepage content -->
  <app-videos-home *ngIf="idActive == 0"></app-videos-home>
  <app-videos-player *ngIf="idActive == 1"></app-videos-player>
</div>
